/**
 * Image Slider Block JavaScript
 * Only loaded when .image-slider-block is present on page
 */

const imageSliders = document.querySelectorAll('.image-slider-block');

if (imageSliders.length && window.Swiper) {
    imageSliders.forEach(function (slider) {
        // Get data attributes from slider element
        const loop = slider.dataset.loop === 'true';
        const autoplay = slider.dataset.autoplay === 'true';
        const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 3000;
        const slidesMobile = parseInt(slider.dataset.slidesMobile) || 1;
        const slidesTablet = parseInt(slider.dataset.slidesTablet) || 2;
        const slidesDesktop = parseInt(slider.dataset.slidesDesktop) || 3;
        const spaceBetween = parseInt(slider.dataset.spaceBetween) || 30;
        const enableMobile = slider.dataset.enableMobile !== 'false';
        const enableTablet = slider.dataset.enableTablet !== 'false';
        const enableDesktop = slider.dataset.enableDesktop !== 'false';
        
        // Note: CSS already handles initial layout via data attributes
        // JavaScript only adds interactive Swiper functionality
        
        let swiperInstance = null;
        
        // Function to check if Swiper should be enabled for current window width
        function shouldEnableSwiper() {
            const width = window.innerWidth;
            if (width < 768) {
                return enableMobile;
            } else if (width < 992) {
                return enableTablet;
            } else {
                return enableDesktop;
            }
        }
        
        // Function to initialize Swiper
        function initSwiper() {
            if (swiperInstance) return; // Already initialized
            
            slider.classList.remove('swiper-disabled');
            slider.classList.add('swiper-initialized');
            
            const swiperConfig = {
                loop: loop,
                init: true,
                slidesPerView: slidesMobile,
                spaceBetween: spaceBetween,
                on: {
                    init() {
                        slider.classList.remove('loadSlider');
                    }
                },
                breakpoints: {
                    768: {
                        slidesPerView: slidesTablet,
                        spaceBetween: spaceBetween
                    },
                    992: {
                        slidesPerView: slidesDesktop,
                        spaceBetween: spaceBetween
                    }
                }
            };
            
            // Add navigation if arrows exist
            const prevButton = slider.querySelector('.swiper-button-prev');
            const nextButton = slider.querySelector('.swiper-button-next');
            if (prevButton && nextButton) {
                swiperConfig.navigation = {
                    prevEl: prevButton,
                    nextEl: nextButton
                };
            }
            
            // Add pagination if element exists
            const pagination = slider.querySelector('.swiper-pagination');
            if (pagination) {
                swiperConfig.pagination = {
                    el: pagination,
                    clickable: true
                };
            }
            
            // Add autoplay if enabled
            if (autoplay) {
                swiperConfig.autoplay = {
                    delay: autoplaySpeed,
                    disableOnInteraction: false
                };
            }
            
            swiperInstance = new Swiper(slider.querySelector('.s-image-slider'), swiperConfig);
        }
        
        // Function to destroy Swiper
        function destroySwiper() {
            if (!swiperInstance) return; // Not initialized
            
            swiperInstance.destroy(true, true);
            swiperInstance = null;
            slider.classList.add('swiper-disabled');
            slider.classList.remove('loadSlider');
        }
        
        // Initialize or destroy based on current window size
        function handleResize() {
            if (shouldEnableSwiper()) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }
        
        // Initial setup
        handleResize();
        
        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(handleResize, 250);
        });
    });
}

